import { Divider, Flex, Link, Text } from "@/atoms"
import { DisconnectOutlined, FolderOpenOutlined } from "@/icons"
import {
  ConfigItem,
  DescriptionLabelConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { INTEGRATIONS_WRITE_PERMISSION } from "@/pages/IntegrationsPage/IntegrationsPage.constants"
import { GitHubConfigurationForm } from "./GitHubConfigurationForm"
import {
  getGithubHostDisplay,
  getGitHubInstallationUrl
} from "./GitHubConfigurationItem.selector"

import styles from "./GitHubConfigurationItem.module.scss"

import type { GitHubConfigurationItemProps } from "."

export const GitHubConfigurationItem = (
  props: GitHubConfigurationItemProps
) => {
  const [
    _,
    { isPending, onRemove, onReset, isDirty, form, onFieldsChange, onUpdate, t }
  ] = useIntegration(props)
  const { keyPrefix, values } = props
  const { repoCount, id, host } = values
  const installationUrl = getGitHubInstallationUrl(values)

  return (
    <ConfigItem
      key={id}
      values={values}
      Aside={
        <Link target="_blank" href={installationUrl}>
          {t(`${keyPrefix}configureInGithub`)}
        </Link>
      }
      Description={
        <Flex gap={8} align="center">
          <DescriptionLabelConfigItem
            Icon={FolderOpenOutlined}
            tKey={`${keyPrefix}reposConnected`}
            count={Number(repoCount)}
          />
          <Divider type="vertical" className={styles.separator} />
          <Text type="secondary">{getGithubHostDisplay(host)}</Text>
        </Flex>
      }
    >
      <GitHubConfigurationForm
        values={values}
        installationUrl={installationUrl}
        form={form}
        onFieldsChange={onFieldsChange}
        onUpdate={onUpdate}
      />
      <FooterConfigItem
        formId={id}
        isDirty={isDirty}
        isPending={isPending}
        permissions={INTEGRATIONS_WRITE_PERMISSION}
        removeTKey="general.disconnect"
        RemoveIcon={DisconnectOutlined}
        onRemove={() => onRemove(values)}
        onReset={onReset}
      />
    </ConfigItem>
  )
}
